(() => {
  'use strict';
  if (window.__studioCommerceV3Loaded) return;
  window.__studioCommerceV3Loaded = true;

  const root = window.Shopify?.routes?.root || '/';

  function toast(message) {
    let el = document.querySelector('.studio-cart-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'studio-cart-toast';
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(el._timer);
    el._timer = setTimeout(() => el.classList.remove('is-visible'), 2600);
  }

  async function addItems(items) {
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ items })
    });
    if (!response.ok) {
      let message = 'Toevoegen aan winkelwagen is niet gelukt.';
      try {
        const data = await response.json();
        message = data.description || data.message || message;
      } catch (_) {}
      throw new Error(message);
    }
    return response.json();
  }

  document.addEventListener('click', async (event) => {
    const bundle = event.target.closest('[data-studio-bundle-add]');
    if (bundle) {
      event.preventDefault();
      const section = bundle.closest('[data-studio-bundle]');
      const checked = [...section.querySelectorAll('[data-bundle-check]:checked')];
      const items = checked
        .map(input => ({id:Number(input.value), quantity:1}))
        .filter(item => item.id);
      if (!items.length) {
        toast('Selecteer minimaal één product.');
        return;
      }
      bundle.disabled = true;
      const old = bundle.textContent;
      bundle.textContent = 'Toevoegen...';
      try {
        await addItems(items);
        toast(`${items.length} product${items.length === 1 ? '' : 'en'} toegevoegd`);
        document.dispatchEvent(new CustomEvent('studio:cart:updated'));
      } catch (error) {
        toast(error.message);
      } finally {
        bundle.disabled = false;
        bundle.textContent = old;
      }
    }

    const mobileFilter = event.target.closest('[data-studio-filter-open]');
    if (mobileFilter) {
      const panel = document.querySelector('[data-studio-mobile-filters]');
      panel?.classList.toggle('studio-v3-hidden');
    }
  });

  function initRecommendations(rootNode = document) {
    rootNode.querySelectorAll('[data-studio-remote-section]').forEach((container) => {
      if (container.dataset.loaded === 'true') return;
      const url = container.dataset.url;
      if (!url) return;
      container.dataset.loaded = 'true';
      fetch(url)
        .then(r => r.text())
        .then(html => {
          const temp = document.createElement('div');
          temp.innerHTML = html;
          const incoming = temp.querySelector('[data-studio-remote-section]');
          if (!incoming || !incoming.innerHTML.trim()) {
            container.remove();
            return;
          }
          container.innerHTML = incoming.innerHTML;
        })
        .catch(() => container.remove());
    });
  }

  function initReveal(rootNode = document) {
    const nodes = rootNode.querySelectorAll('.studio-v3-reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      nodes.forEach(n => n.classList.add('is-visible'));
      return;
    }
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, {threshold:.08});
    nodes.forEach(n => io.observe(n));
  }

  function init(rootNode = document) {
    initRecommendations(rootNode);
    initReveal(rootNode);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', e => init(e.target));
})();

